import { differenceInDays } from 'date-fns'

import { MESSAGE_AUTHOR_TYPE } from '@lyrahealth-inc/shared-app-logic'

import { Message } from '../ui-models'

/**
 * Checks if there are any messages from a provider in the conversation
 * @param messages - Array of Message objects
 * @returns true if at least one message has authorType === "provider", false otherwise
 */
export const hasProviderMessages = (messages: Message[]): boolean => {
  if (!messages || messages.length === 0) {
    return false
  }

  return messages.some((message) => message.authorType === MESSAGE_AUTHOR_TYPE.PROVIDER)
}

/**
 * Calculates the number of days elapsed since the first message from a specific author type
 * @param messages - Array of Message objects
 * @param authorType - The author type to filter by (e.g., MESSAGE_AUTHOR_TYPE.PROVIDER or MESSAGE_AUTHOR_TYPE.PATIENT)
 * @returns Number of days since the first message from the specified author type, or null if no messages found
 */
export const getDaysSinceFirstMessageFromAuthor = (messages: Message[], authorType: string): number | null => {
  if (!messages || messages.length === 0) {
    return null
  }

  const messagesFromAuthor = messages.filter((message) => message.authorType === authorType)

  if (messagesFromAuthor.length === 0) {
    return null
  }

  let firstMessage = messagesFromAuthor[0]
  for (const message of messagesFromAuthor) {
    if (new Date(message.dateCreated) < new Date(firstMessage.dateCreated)) {
      firstMessage = message
    }
  }

  return differenceInDays(new Date(), new Date(firstMessage.dateCreated))
}
